const mainDescriptionColumn = document.querySelector('.collection__columbs-item');
if (!mainDescriptionColumn) return;

let secondDescriptionColumn;
const contentChildren = mainDescriptionColumn.children;

const halfThreshold = (mainDescriptionColumn.offsetHeight + 70) / 2;
let passedHalf = false;
let split = false;

for (const childNode of contentChildren) {
  if (!split) {
    passedHalf = childNode.offsetTop - mainDescriptionColumn.offsetTop + childNode.offsetHeight > halfThreshold;
  }

  if (!split && passedHalf && childNode.tagName.toLowerCase() === 'h3') {
    const breakingPoint = childNode.outerHTML.replace(/(<h3>)/, '</div><div class="collection__columbs-item"><h3>');
    mainDescriptionColumn.outerHTML = mainDescriptionColumn.outerHTML.replace(childNode.outerHTML, breakingPoint);
    break;
  }
}